import React from "react";

import { Container, Title, Description } from "./styles";

export default class TermsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDivisionKey: -1,
      isDivisionOpen: false,
      activeModelKey: -1,
      isModelOpen: false,
    };
  }

  toggleDivision() {
    this.setState({
      isDivisionOpen: !this.state.isDivisionOpen,
    });
  }

  changeDivision(e) {
    if (this.state.activeDivisionKey === e.target.value) {
      this.setState({
        activeDivisionKey: -1,
        isDivisionOpen: false,
        activeModelKey: -1,
      });
    } else {
      this.setState({
        activeDivisionKey: e.target.value,
        isDivisionOpen: false,
        activeModelKey: -1,
      });
    }
  }

  toggleModel() {
    this.setState({
      isModelOpen: !this.state.isModelOpen,
    });
  }

  changeModel(e) {
    if (this.state.activeModelKey === e.target.value) {
      this.setState({
        activeModelKey: -1,
        isModelOpen: false,
      });
    } else {
      this.setState({
        activeModelKey: e.target.value,
        isModelOpen: false,
      });
    }
  }

  render() {
    //    const divisionOptions = ["Construction", "Forestry", "Hitachi", "Waratah"];
    return (
      <Container className={"terms"}>
        <Title>Terms of Use and Legal Notice</Title>
        <Description>
          <p>
            These Terms of Use were last updated on 2/23/2018. These Terms of Use apply only to{" "}
            <a style={{ color: "#FF3600", textDecoration: "none" }} href="https://bobcatonlinetraining.com/">
              bobcatonlinetraining.com
            </a>
          </p>
          <p>
            PLEASE READ CAREFULLY! BY USING THIS WEBSITE, YOU AGREE TO BE BOUND BY THESE TERMS OF USE. Welcome
            to the Terms of Use for the Bobcat Company (“we” or “us” or “Bobcat”) website located at{" "}
            <a style={{ color: "#FF3600", textDecoration: "none" }} href="https://bobcatonlinetraining.com/">
              bobcatonlinetraining.com
            </a>{" "}
            (this “website”). By using this website, you agree to be bound by the terms and conditions set
            forth in these Terms of Use. If you do not agree to these Terms of Use, you may not use this
            website.
          </p>
          <h2>Modifications & Amendments</h2>
          <p>
            We regularly update and modify our website, including these Terms of Use. If we modify or amend
            these Terms of Use, the changes will be incorporated into this document and we will revise the
            “last updated” date at the top of this web page. Modifications to these Terms of Use will become
            effective immediately after they are initially posted on this website. Please review these Terms
            of Use periodically for changes. Your continued use of this website following the posting of
            changes to the Terms of Use constitutes acceptance of those changes. While we endeavor to keep
            this website’s descriptions of our products and related services up to date, you should verify
            this information with customer support.
          </p>
          <h2>Permitted Uses</h2>
          <p>
            You may view, use and download small portions of the product descriptions, other data, text,
            graphics, software, audio and video files and photos on this website (“content”) for your
            informational, non-commercial use, provided that you leave all the copyright, trademark and other
            proprietary notices intact. You may only use this website for the purposes expressly set forth in
            these Terms of Use. Any other use of this website is prohibited. You may only use this website as
            permitted by law. We may prohibit your use of this website if you do not comply with these Terms
            of Use.
          </p>
          <h2>Prohibited Uses & Rules of Conduct</h2>
          <p>
            Certain areas of this website may permit you to upload or post content (such as messages and
            feedback), or to otherwise interact with this website and its participants. You may only use this
            website for lawful purposes.
          </p>
          <p>You may not use this website:</p>
          <ul>
            <li>(a) for any illegal purpose or in any way that violates any applicable law or regulation;</li>
            <li>
              (b) to upload, post, email or distribute any content that you do not have a right to transmit
              under any law or under contractual or fiduciary relationships (such as inside information,
              confidential information learned or disclosed as part of employment relationships or under
              nondisclosure agreements);
            </li>
            <li>
              (c) to upload, post, email or distribute the proprietary information of another (whether
              protected by copyright, trademark, trade secret, right of publicity or other proprietary right)
              without the express permission of the owner of such right; any person who has been found
              repeatedly to violate the intellectual property rights of others shall be barred from accessing
              or using this website;
            </li>
            <li>
              (d) to copy, sell, resell or exploit for commercial purposes, any portion of this website in any
              way that violates these Terms of Use;
            </li>
            <li>
              (e) to upload, post, email or distribute any content that is unlawful, deceptive, misleading,
              false, counterfeit, stolen, threatening, harassing, abusive, obscene, pornographic, defamatory,
              racially or ethnically objectionable or in violation of the personal privacy rights of another;
            </li>
            <li>
              (f) to forge headers, manipulate identifiers or otherwise engage in any activities intended to
              withhold or cloak a user’s identity or contact information;
            </li>
            <li>
              (g) to upload, post, email or distribute any content that contains software viruses, trap doors,
              hot keys, time bombs or any other computer code designed to interrupt, destroy or limit the
              functionality of any computer software or hardware or telecommunications equipment;
            </li>
            <li>
              (h) to use any device, software or routine to interfere or attempt to interfere with the proper
              working of this website;
            </li>
            <li>
              (i) to use any robot, spider, other automatic device, or manual process to monitor or copy any
              website pages or any content without our prior express written permission;
            </li>
            <li>
              (j) to take any action that imposes an unreasonable or disproportionately large load on our
              infrastructure as determined by us in our sole discretion;
            </li>
            <li>(k) to send unsolicited commercial messages or communications in any form (spam);</li>
            <li>
              (l) to decompile, disassemble, reverse engineer or otherwise attempt to discover the source code
              or trade secrets of this website; or
            </li>
            <li>(m) to assist or permit any persons in engaging in any of the activities described above.</li>
          </ul>
          <p>Each user of this website further agrees that they are:</p>
          <ul>
            <li>
              (a) responsible for the content that he or she creates and submits to this website, and the
              consequences of its use or submission;
            </li>
            <li>
              (b) responsible for ensuring that the content that the user transmits and receives through this
              website complies with all applicable laws and regulations (including those relating to export
              control) and these Terms of Use; and
            </li>
            <li>
              (c) responsible for ensuring that all content the user transmits to this website is accurate,
              truthful, up-to-date and complete.
            </li>
          </ul>
          <p>
            We may preserve content and may also disclose content and its origin if required to do so by law
            or in the good-faith belief that such preservation or disclosure is reasonably necessary to:
          </p>
          <ul>
            <li>(a) comply with legal process;</li>
            <li>(b) enforce these Terms of Use;</li>
            <li>(c) respond to claims that any content violates the rights of third parties; or</li>
            <li>(d) protect the rights, property, or personal safety of website users, the public and us.</li>
          </ul>
          <h2>User Content</h2>
          <p>
            By submitting, uploading, storing, sending or receiving content of any kind, you give Bobcat (and
            those we work with) a perpetual, irrevocable, worldwide, royalty-free, sublicensable (through
            multiple tiers) license to use, reproduce, cache, store, modify, publicly perform, publicly
            display, delete from, add to, distribute and transmit such content for any purpose, and waive any
            publicity rights in such content. This license continues even if you stop using our services or
            this website.
          </p>
          <h2>Monitoring Usage & Content</h2>
          <p>
            Bobcat cannot pre-screen all of the content submitted to this website. By using this website, you
            agree that Bobcat cannot be responsible for policing, monitoring or editing such content. Bobcat
            shall have the right, but not the obligation, to monitor content and use of this website to
            improve its performance, for legal and regulatory requirements, and to determine compliance with
            these Terms of Use and other applicable policies and procedures of Bobcat. Bobcat shall have the
            right in its sole discretion to refuse to post, or to remove, any content on this website for any
            reason. Bobcat will look into possible violations when information that is sufficient to warrant
            an investigation is brought to Bobcat's attention.
          </p>
          <h2>Pricing</h2>
          <p>
            Bobcat may choose to list manufacturer-suggested retail pricing or promotion pricing of its
            products and services. Bobcat reserves the right to change product prices, specifications or
            options at any time without prior notice. The listed prices do not include freight, dealer prep,
            surcharges, sales tax or options and accessories. The selling dealer will determine the final
            sales price. Pricing is country specific.
          </p>
          <h2>Specifications</h2>
          <p>
            Certain specifications are based on engineering calculations and are not actual measurements.
            Specifications are provided for comparison purposes only and are subject to change without notice.
            Specifications for your individual parts will vary based on normal variations in design,
            manufacturing, operating conditions, and other factors.
          </p>
          <h2>No Warranties</h2>
          <p>
            EXCEPT AS OTHERWISE EXPRESSLY PROVIDED IN THE APPLICABLE PURCHASE AGREEMENT, IF ANY, THIS WEBSITE
            AND ALL CONTENT, PARTS, OTHER PRODUCTS AND SERVICES AVAILABLE ON OR THROUGH THIS WEBSITE
            (COLLECTIVELY, “MATERIALS”) ARE PROVIDED TO YOU ON AN “AS IS” “AS AVAILABLE” BASIS WITHOUT
            WARRANTY OF ANY KIND EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, DATA ACCURACY,
            SYSTEMS INTEGRATION OR QUIET ENJOYMENT. BOBCAT AND ITS AFFILIATES MAKE NO WARRANTY AS TO THE
            COMPLETENESS, TIMELINESS, OR RELIABILITY OF ANY MATERIALS AVAILABLE ON OR THROUGH THIS WEBSITE.
            YOU ARE RESPONSIBLE FOR VERIFYING INFORMATION BEFORE RELYING ON IT. USE OF THE MATERIALS IS AT
            YOUR SOLE RISK.
          </p>
          <p>
            BOBCAT MAKES NO REPRESENTATIONS OR WARRANTIES THAT USE OF THIS WEBSITE WILL BE UNINTERRUPTED,
            ERROR-FREE OR COMPLETELY SECURE. YOU ARE RESPONSIBLE FOR TAKING ALL NECESSARY PRECAUTIONS TO
            ENSURE THAT ANY CONTENT YOU MAY OBTAIN FROM THIS WEBSITE IS FREE OF VIRUSES AND OTHER POTENTIALLY
            HARMFUL DEVICES. YOUR USE OF THIS WEBSITE CONSTITUTES ACCEPTANCE OF THIS DISCLAIMER OF WARRANTIES.
          </p>
          <h2>Limitation of Liability</h2>
          <p>
            TO THE EXTENT PERMITTED BY LAW, THE TOTAL LIABILITY OF BOBCAT, AND ITS AFFILIATES, AND THOSE WE
            WORK WITH, FOR ANY CLAIMS UNDER THESE TERMS OF USE, INCLUDING FOR ANY IMPLIED WARRANTIES, WILL NOT
            EXCEED THE AMOUNT YOU PAID TO US TO USE THIS WEBSITE. YOU FURTHER AGREE THAT IN NO EVENT WILL
            BOBCAT, ITS AFFILIATES, AND THOSE WE WORK WITH, BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT,
            OR CONSEQUENTIAL DAMAGES WHATSOEVER ARISING FROM YOUR ACCESS OR USE OF, OR INABILITY TO ACCESS OR
            USE THIS WEBSITE.
          </p>
          <h2>Bobcat’s Logo & Trademarks</h2>
          <p>
            The "Bobcat®" trademark and logo are trademarks of Bobcat. Unauthorized use of any Bobcat
            trademarks, service marks, or logos may be a violation of federal and state trademark laws.
          </p>
          <p>
            Bobcat and/or its licensors own all intellectual property rights in this website. This website is
            protected by U.S. and international copyright laws. Except as expressly described in the “Scope of
            Use” section above, you may not modify, reproduce, perform or display (a) the content on this
            website; (b) the design or layout of this website, or individual sections of the design or layout
            of this website; or (c) Bobcat trademarks, service marks or logos without our written permission.
          </p>
          <p>
            Please see this website for our additional policies, including, without limitation, our procedures
            relating to Copyright Infringement all of which are incorporated herein by reference.
          </p>
          <h2>Links</h2>
          This website may contain links to websites operated by other parties. The linked sites are not under
          the control of Bobcat, and Bobcat is not responsible for the content available on any other Internet
          sites linked to this website. Such links do not imply Bobcat's endorsement of material on any other
          site, and Bobcat disclaims all liability with regard to your access to such linked sites. Bobcat
          provides links to other Internet sites as a convenience to users, and access to any other Internet
          sites linked to this website is at your own risk. Unless otherwise set forth in a written agreement
          between you and Bobcat, you may link to our website, provided that you adhere to the following: (i)
          any link to Bobcat's website must be a text- only link and clearly marked “Bobcat Parts website,”
          (ii) the appearance, position and other aspects of the link may not be such as to damage or dilute
          the goodwill associated with Bobcat's name and trademarks, (iii) the link must “point” to our home
          page at the URL www.bobcatparts.com and not to other pages within the website, (iv) the appearance,
          position and other attributes of the link may not create the false appearance that your organization
          or entity is sponsored by, affiliated with, or associated with Bobcat, (v) when selected by a user,
          the link must display the Bobcat Parts website on full-screen and not within a “frame” on the
          linking site and (vi) Bobcat reserves the right to revoke its consent to the link at any time and in
          its sole discretion. You must not establish a link from any website that is not owned by you.
          <h2>Email</h2>
          <p>
            {" "}
            Email submissions over the Internet may not be secure. Please consider this fact before emailing
            any personal or confidential information.
          </p>{" "}
          <h2>Violations</h2>
          <p>
            {" "}
            We reserve the right to seek all remedies available at law and in equity for violations of these
            Terms of Use, including suspending or blocking your access to this website.
          </p>{" "}
          <h2>Governing Law and Miscellaneous</h2>
          <p>
            {" "}
            The laws of the State of North Dakota shall govern any controversy or claim arising out of or
            relating to these Terms or Use or this website, without reference to its choice of law rules. This
            website is operated by Bobcat from the United States of America. We make no representation that
            the information in this website is appropriate or available for use in other locations, and access
            to the this website from territories where the content of this website may be illegal is
            prohibited. Those who choose to access this website from other locations do so on their own
            initiative and are responsible for compliance with applicable local laws. These Terms of Use
            constitute the entire agreement between Bobcat and you with respect to your use of the
            www.bobcatparts.com website.
          </p>{" "}
          <h2>Arbitration</h2>
          <p>
            {" "}
            Any controversy or claim arising out of or relating to these Terms or Use or this website shall be
            settled by binding arbitration in accordance with the commercial arbitration rules of the American
            Arbitration Association. Any such controversy or claim shall be arbitrated on an individual basis,
            and shall not be consolidated in any arbitration with any claim or controversy of any other party.
            The arbitration shall be conducted in Cass County, North Dakota, and judgment on the arbitration
            award may be entered into any court having jurisdiction thereof. Notwithstanding anything to the
            contrary in the foregoing, Bobcat may obtain from a court any interim or provisional relief that
            may be necessary to protect Bobcat’s rights or property.
          </p>{" "}
          <h2>Questions</h2>
          <p>
            If you have any questions about our Terms of Use, please{" "}
            <a
              href={"/help-center"}
              style={{
                color: "#FF3600",
                textDecoration: "none",
              }}>
              contact us
            </a>
            .
          </p>
          <p> © 2023 Bobcat Company. All rights reserved.</p>
        </Description>
      </Container>
    );
  }
}
